import { REMOVE_MFA, COMPLETE_MFA, STORE_MFA_PROCESS } from '../actions/mfa/mfa';

const defaultState = {
  activeProcesses: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case STORE_MFA_PROCESS:
      return {
        ...state,
        activeProcesses: {
          ...state.activeProcesses,
          [action.payload.mfaToken]: action.payload.mfaProcess,
        },
      };
    case COMPLETE_MFA:
      return {
        ...state,
        activeProcesses: {
          ...state.activeProcesses,
          [action.payload.mfaToken]: {
            ...state.activeProcesses[action.payload.mfaToken],
            authenticated: true,
          },
        },
      };
    case REMOVE_MFA:
      // eslint-disable-next-line no-case-declarations
      const { [action.payload.mfaToken]: remove, ...processes } = state.activeProcesses;
      return {
        ...state,
        activeProcesses: processes,
      };
    default:
      return state;
  }
};
